

import React, { memo } from 'react';
import cx from 'classnames';
import _memoize from 'lodash.memoize';
import { getMinutes } from '@shootsta/format-seconds';
import { Text } from '../../../../../ui-kit';
import CommentAssetPreview from './CommentAssetPreview';
import ContentView from '../../ContentView';
import UserProfile from '../../../common/UserProfile';
import Replies from '../../../common/Replies';
import CommentTitle from './CommentTitle';
import CommentsListV2 from './CommentsListV2';
import { getUser } from '../../../../../common/utils';
import '../styles/_comments-list.scss';

const UNKNOWN = 'Unknown';

















const getClipAssetId = _memoize((clipId, clips) => {
  const { assetId } = clips.find(({ clipId: commentClipId }) => commentClipId === clipId) || {};

  if (!assetId) {
    return null;
  }

  return assetId;
});

export const getFormattedTimestamp = _memoize((timestamp) => {
  if (Number.isNaN(Number(timestamp))) {
    return UNKNOWN;
  }

  return getMinutes(timestamp);
});

const getVisibleComments = (comments, clips) => comments.reduce((visibleComments, comment) => {
  const {
    parentId,
    clipId,
    assetId,
    timestamp,
    isAddedByCommentForm
  } = comment;

  if (parentId) {
    return visibleComments;
  }

  const commentAssetId = clipId && clips.length ?
  getClipAssetId(clipId, clips) :
  assetId;

  if (!commentAssetId && !isAddedByCommentForm) {
    return visibleComments;
  }

  return [
  ...visibleComments,
  {
    ...comment,
    timestamp,
    commentAssetId
  }];

}, []);

function CommentsList({
  comments,
  className,
  clips = [],
  getUserColor,
  getNumberComments,
  isNewV2Design = false,
  fetchAssets,
  assetsMap
}) {
  const visibleComments = getVisibleComments(comments, clips);
  const numberComments = visibleComments.length;

  if (getNumberComments) {
    getNumberComments(numberComments, visibleComments);
  }

  if (isNewV2Design) {
    return (
      <CommentsListV2
        visibleComments={visibleComments}
        getFormattedTimestamp={getFormattedTimestamp}
        fetchAssets={fetchAssets}
        assetsMap={assetsMap} />);


  }

  return (
    <div className={cx('comments-list', className)}>
      {!numberComments &&
      <div className="comments-list__empty">
          <Text>No one has left any comments.</Text>
        </div>}

      {visibleComments.map((comment, commentIndex) => {
        const {
          commentId,
          content,
          createdByUser,
          children: replies,
          timestamp,
          commentAssetId
        } = comment;

        const { userId, name, imageUrl, isUser } = getUser(createdByUser);

        const { color, brightness } = getUserColor({ userId });

        return (
          <div key={commentId} className="comments-list__comment">
            <CommentAssetPreview assetId={commentAssetId} />
            <div className="comments-list__comment__content-wrapper">
              <div className="comments-list__comment__content-wrapper__heading">
                <CommentTitle
                  color={color}
                  brightness={brightness}
                  assetId={commentAssetId}
                  commentIndex={commentIndex} />

                <p className="comments-list__comment__content-wrapper__heading__time">
                  {getFormattedTimestamp(timestamp)}
                </p>
              </div>
              <ContentView content={content} truncate />
              <div className="comments-list__comment__content-wrapper__footer">
                <UserProfile
                  imageUrl={imageUrl}
                  color={color}
                  name={name}
                  isUser={isUser} />

                <Replies replies={replies} />
              </div>
            </div>
          </div>);

      })}
    </div>);

}

export default memo(CommentsList);